import { RoleRegisterMessages, TranslationRoleRegisterMessages } from "../interfaces/roleRegisterMessages";

export const messages: TranslationRoleRegisterMessages = {
  [RoleRegisterMessages.titleCreate]: "Crear grupo",
  [RoleRegisterMessages.titleEdit]: "Editar grupo",
  [RoleRegisterMessages.stepTabFormRole]: "Datos del grupo",
  [RoleRegisterMessages.stepTabAddUsers]: "Agregar usuarios",
  [RoleRegisterMessages.noUsersRegistered]: "No hay usuarios registrados",
  [RoleRegisterMessages.userIsAMemberOfAnotherRole]: "El usuario seleccionado ya pertenece a otro grupo."
   + " Al confirmar, pasará a pertenecer a este grupo."
};